"use client";

import { useTranslation } from "next-i18next";
import {
	formatMapCoordinates,
	getGoogleMapsUrl,
	getWazeUrl,
} from "@/lib/map-navigation-links";
import styles from "./index.module.scss";

type LocationMapDrawerProps = {
	open: boolean;
	lat: number;
	lng: number;
	accentColor?: string;
};

export function LocationMapDrawer({
	open,
	lat,
	lng,
	accentColor,
}: LocationMapDrawerProps) {
	const { t } = useTranslation();

	return (
		<div
			className={`${styles.drawer} ${open ? styles.drawerOpen : ""}`}
			style={
				accentColor
					? ({ "--map-accent": accentColor } as React.CSSProperties)
					: undefined
			}
			aria-hidden={!open}
		>
			<div className={styles.inner}>
				<p className={styles.label}>{t("gps")}</p>
				<p className={styles.coordinates}>{formatMapCoordinates(lat, lng)}</p>
				<div className={styles.actions}>
					<a
						className={`${styles.link} ${styles.linkPrimary}`}
						href={getGoogleMapsUrl(lat, lng)}
						target="_blank"
						rel="noreferrer"
						tabIndex={open ? 0 : -1}
					>
						{t("openInGoogleMaps")}
					</a>
					<a
						className={`${styles.link} ${styles.linkSecondary}`}
						href={getWazeUrl(lat, lng)}
						target="_blank"
						rel="noreferrer"
						tabIndex={open ? 0 : -1}
					>
						{t("openInWaze")}
					</a>
				</div>
			</div>
		</div>
	);
}
